const businessConfig = {
  disabledReturnsStores: new Set(['store_01HQJE3KCXP8ZRY6761B3DJHZY']),
};

export default businessConfig;
